
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electronic-terms-conditions",
      function () {
        return require("private-next-pages/electronic-terms-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electronic-terms-conditions"])
      });
    }
  